/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
  "account": "帐户",
  "active_date": "激活日期",
  "address": "地址",
  "address2": "地址(选填)",
  "amount": "金额",
  "and": "和",
  "article": "协议条款",
  "buy": "购买",
  "buyer": "买家",
  "buyer_info": "买家信息",
  "cancel": "返回",
  "canceled": "已取消",
  "cellphone": "手机",
  "certification_expires": "未经授权或过期，请重新登录。",
  "change_password": "更改密码",
  "city": "城市",
  "clear": "重置",
  "commercial": "商业",
  "company": "公司",
  "completed": "已完成",
  "confirm_password": "确认密码",
  "contact": "联系方式",
  "country": "国家",
  "create": "创建",
  "create_account": "创建帐户",
  "create_date": "创建日期",
  "creationdate": "创建日期",
  "currency": "货币",
  "customer_success": "注册成功，请查看您的电子邮箱并完成激活",
  "dead_line": "最终日期",
  "dealer": "经销商",
  "dealer_success": "等待审核",
  "description": "说明",
  "domain": "域名",
  "domain_in_use": "域名已被使用。",
  "email": "邮箱",
  "email_format_error": "请输入正确的邮箱地址",
  "email_used": "该邮箱已被使用",
  "enter_character": "输入图片中的字符",
  "enter_confirm_password": "请再次输入新密码",
  "enter_new_password": "请输入新密码",
  "enter_old_password": "请输入旧密码",
  "erp_list": "订阅列表",
  "erp_status": "状态",
  "expire_date": "过期日期",
  "female": "女",
  "first_name": "名",
  "forget_password": "忘记密码",
  "forgot_password": "忘记密码了？",
  "form_not_exist": "表单不存在",
  "format_error": "格式错误",
  "group_code": "组别",
  "group_name": "组名",
  "home_company_address": "家庭/公司地址",
  "image": "图像",
  "information_success": "修改账户信息成功",
  "initial_info": "初始信息",
  "input_password": "请输入密码",
  "input_password_again": "请再次输入密码",
  "last_name": "姓",
  "legal_person": "法人",
  "male": "男",
  "modify": "修改",
  "modify_erp_information": "修改 ERP 信息",
  "modules": "模块",
  "month": "用户/月",
  "name": "名称",
  "new_password": "新密码",
  "new_password_toEmail": "我们已经发送了一个新密码到你邮件",
  "next": "下一个",
  "noFoundurl": "实例不存在",
  "not_null": "有必填项未填写",
  "official_website": "官方网站：",
  "ok": "好",
  "old_password": "旧密码",
  "old_password_error": "旧密码不匹配",
  "one_time_payment": "购买",
  "operation": "操作",
  "or": "或",
  "order": "订单号",
  "order-no": "订单号",
  "order_close": "订单已关闭",
  "order_list": "订单列表",
  "order_no": "订单号",
  "order_status": "订单状态",
  "other": "其他",
  "paid": "已付款",
  "password": "密码",
  "password_error": "密码必须由6-20位数字加字母组成！",
  "password_error_two": "两次输入密码不一致！",
  "password_least": "密码至少6位且包含数字和字母/特殊字符",
  "password_strength": "密码强度",
  "pay": "付款",
  "pay_error": "获取支付信息失败",
  "payment": "支付方式",
  "payment_date": "付款日期",
  "personal": "个人",
  "please_email": "请检查你的邮箱",
  "pos": "序号",
  "previous": "上一个",
  "price": "价格",
  "privacy": "通过创建SOMATIME账户，我理解并同意SOMATIME的",
  "privacy_notice": "隐私声明",
  "product": "产品",
  "product_list": "产品列表",
  "product_name": "产品名",
  "purchase": "购买",
  "purchase_success": "购买成功",
  "refunded": "已退款",
  "registered": "此邮箱地址已被注册",
  "registered_email_address": "我们已注册您的电子邮件地址",
  "renewal": "续费",
  "repeat_password": "重复密码",
  "requied": "此项必填",
  "requied_num": "仅数字",
  "require_tips": "买家必填信息缺失",
  "required": "必填",
  "reseller": "经销商",
  "resend": "重发",
  "reset_password": "我们已发送一封密码确认邮件至",
  "revoke": "关闭订单",
  "revoke_tip1": "是否关闭当前订单？",
  "role": "角色",
  "search": "搜索",
  "send_update": "从SOMATIME向我发送更新",
  "sex": "性别",
  "signIn": "登录",
  "sign_out": "登出",
  "state": "州/省",
  "status": "支付状态",
  "status_not_match": "状态不符",
  "strength_high": "高",
  "strength_low": "低",
  "strength_mid": "中",
  "submit": "确定",
  "submitted": "已提交",
  "subscribe": "订阅",
  "subscribe-mon": "订阅月数",
  "subscript_success": "订阅成功",
  "telephone": "电话",
  "tenant_list": "租户列表",
  "tenant_management_system": "租户管理系统",
  "tenant_system": "租户系统",
  "terms_of_use": "使用条款",
  "time_info": "时间信息",
  "title": "称呼",
  "unpaid": "未付款",
  "update_password_success": "密码修改成功",
  "user": "用户",
  "user_check": "请先阅读并勾选同意隐私声明和使用条款",
  "user_id": "用户编码",
  "user_month": "月数",
  "user_not_active": "用户未激活",
  "user_not_exist": "用户名不存在",
  "user_password_error": "密码错误",
  "user_qty": "用户数量",
  "username": "用户名",
  "ver_code_error": "验证码错误",
  "ver_code_exd": "验证码已过期",
  "visit": "访问",
  "welcome_to_iceq": "欢迎来到SOMATIME",
  "zip": "邮编",
  "trial": "试用",
  "requesting_a_trial": "申请成功！您将在24小时内收到申请的demo信息。",
  "trial_orders_have_been_requested": "已申请过试用",
  "apply_trial": "申请试用",
  "request_": "申 请",
  "trial_": "试 用",
  "on_trial": "试用中",
  "order_not_exist": "订单不存在",
  "wait_for_payment": "待付款",
  "trial_reject": "拒绝试用",
  "tips": "提示",
  "confirm": "确认",
  "cancel": "取消",
  "trial_only_allow_one_time_payment_method": "申请试用时，支付方式只能选择购买",
  "domain_info": "域名信息",
  "please_fill_in_domain_info": "请填写域名信息",
  "user_quantity_and_month_required": "用户数量和月份必填",
  "password_must_be_the_same": "确认密码必须与重置密码一致！",
  "enter_the_password_and_new_password": "请先输入密码和新密码！",
  "wrong_user_name_and_password": "用户名密码错！",
  "close_the_page_without_saving": "未保存，确认关闭页面吗？",
  "cancel_input": "取消输入",
  "user_does_not_exist": "用户不存在",
  "modify_success": "修改成功",
  "email_has_been_used": "邮箱已被使用!",
  "created_successfully": "创建成功",
  "error_tip_10098": "邮件发送失败，请重新申请或联系管理员",
};